import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import Cookies from 'js-cookie';
import { langCodes } from '@/config/langs';

const savedLang = Cookies.get('language');

i18n
  .use(HttpBackend) // load translations from /locales folder
  .use(LanguageDetector) // detect user language
  .use(initReactI18next) // pass i18n to react-i18next
  .init({
    lng: savedLang || 'en', // saved language or fallback
    fallbackLng: 'en',
    supportedLngs: langCodes,
    load: 'languageOnly',
    debug: import.meta.env.DEV,

    ns: ['common', 'auth', 'errors', 'teams', 'integrations', 'public'],
    defaultNS: 'common',

    interpolation: {
      escapeValue: false, // React already escapes
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

  });

export default i18n;